import { TooltipWrapper } from '@crehana/compass.ui';
import MenuCollapse from '@crehana/icons/outline/MenuCollapse';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { transition } from '@crehana/ui';
import cn from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var ActionCollapse = function ActionCollapse(_ref) {
  var isOpen = _ref.isOpen,
    title = _ref.title,
    onClick = _ref.onClick;
  var handleClick = function handleClick(ev) {
    ev.preventDefault();
    ev.stopPropagation();
    onClick();
  };
  var leftPosition = isOpen ? '256px' : '112px';
  return /*#__PURE__*/_jsx("div", {
    className: "tw-fixed tw-hidden sm:tw-block tw-top-[13.2rem] tw-z-2",
    style: {
      left: "calc(".concat(leftPosition, " - 16px)")
    },
    children: /*#__PURE__*/_jsx(TooltipWrapper, {
      message: title,
      position: "right",
      containerClassName: "tw-fixed",
      children: /*#__PURE__*/_jsx("button", {
        type: "button",
        className: cn('tw-rounded-full tw-border-0.4 tw-border-solid tw-flex tw-items-center tw-justify-center tw-w-3.6 tw-h-3.6', 'dark:tw-text-neutral-light-100  dark:tw-border-elevation-dark-04 dark:tw-bg-elevation-dark-01 tw-border-neutral-light-300 tw-bg-neutral-light-100'),
        onClick: handleClick,
        style: {
          transform: "rotate(".concat(isOpen ? '0deg' : '-180deg', ")"),
          transition: transition(['transform', 'left'])
        },
        children: /*#__PURE__*/_jsx(MenuCollapse, {
          ignoreColor: true,
          className: cn('tw-fill-current tw-flex-shrink-0 tw-text-neutral-light-800 dark:tw-text-neutral-light-100'),
          size: 20
        })
      })
    })
  });
};
export default ActionCollapse;